import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BillingCountersDataService {
  private mappedBillingCounterName$: BehaviorSubject<string> =
    new BehaviorSubject<string>('');
  private billingCounterInfo$: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );

  constructor() {}

  setBillingCounterInfo(billingCounters): void {
    this.billingCounterInfo$.next(billingCounters);
    const mappedCounter = billingCounters?.find(
      (printer) => printer?.map_to_this_device
    );
    if (mappedCounter) {
      this.mappedBillingCounterName$.next(mappedCounter?.counter_name);
    }
  }

  getMappedBillingCounterName() {
    return this.mappedBillingCounterName$.asObservable();
  }

  getBillingCounterData() {
    return this.billingCounterInfo$.asObservable();
  }
}
